import { required, integer, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    attribute: {
      id: {
        required: helpers.withMessage(i18n.global.t('Please select an attribute.'), required)
      },
      option_ids: {
        required: helpers.withMessage(i18n.global.t('Please select all options.'), required),
        $each: helpers.forEach({
          required: helpers.withMessage(i18n.global.t('Please select all options.'), required),
          integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
        })
      }
    }
  }
};
